<template>
  <div class="container footer">
    <h1 class="footer">Spotted By An Aviation Lover</h1>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style>
.footer {
  margin-bottom: 0px;
  padding-bottom: 20px;
}
</style>
